<script>
  import { fade } from 'svelte/transition'
  import Cookies from 'js-cookie'
  import Logo from './Logo.svelte'
  import { auth, isAdmin, sheets, currentSheet } from './stores/root.js'

  const signOut = () => {
    Cookies.remove('jwt')
    Cookies.remove('user')
    window.location.reload()
  }
</script>

<header class="px-0 px-sm-2 px-lg-4" in:fade={{ duration: 500 }}>
  <div
    class="d-sm-flex align-items-center justify-content-between p-3 pt-0 pt-sm-3"
  >
    <div class="text-end d-block d-sm-none greeting mobile mb-3">
      Hello {$auth.user.username}! (<button
        class="btn btn-link p-0"
        on:click={signOut}>Sign Out</button
      >)
    </div>

    <Logo />

    <div class="d-flex align-items-center">
      {#if $isAdmin}
        <select
          bind:value={$currentSheet}
          class="form-select"
          aria-label="Select Location"
        >
          {#if $sheets.length === 0}
            <option value={null} disabled>Loading...</option>
          {:else}
            <option value={null} disabled>Select Date</option>
            {#each $sheets as sheet}
              <option value={sheet} selected>{sheet.displayDate}</option>
            {/each}
          {/if}
        </select>
      {/if}

      <!-- {#if !$marketVendor && !$isStaff}
        <select
          bind:value={locationId}
          class="form-select ms-3"
          aria-label="Select Location"
        >
          {#await locationRequest}
            <option value={null} selected disabled>Loading...</option>
          {:then locations}
            <option value={null}>All Locations</option>
            {#each locations as location}
              <option value={location.id}>{location.name}</option>
            {/each}
          {:catch error}
            <option selected disabled>{error}</option>
          {/await}
        </select>
      {/if} -->
    </div>

    <div class="text-center d-none d-sm-block">
      Hello {$auth.user.username}! <br />
      (<button class="btn btn-link p-0" on:click={signOut}>Sign Out</button>)
    </div>
  </div>
</header>

<style>
  header {
    background: rgb(245, 240, 235);
    border-bottom: 1px solid #e1e0df;
  }

  @media screen and (min-width: 768px) {
    header select {
      min-width: 200px;
    }
  }

  @media screen and (min-width: 992px) {
    header select {
      min-width: 300px;
    }
  }

  .greeting {
    font-size: 14px;
  }

  .greeting .btn {
    font-size: 14px;
  }
</style>
